/// <reference path="DOMAttached.js" />
/// <reference path="LegacyHelper.js" />

class GNOMRefreshingStatBox extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		if (this.options.hatchTR != undefined)
			this.el.closest('.tabbedApplication').querySelector('.eggHatchDesc').innerHTML = this.options.hatchTR;

		var timer = setTimeout(this.onTimer.bind(this), 10000);
		this.el.closest('.tabbedApplication').attachedObj.registerTimer(timer);

		if (this.options.petPageUrl != undefined) {
			this.el.closest('.tabbedApplication').attachedObj.activatePlaceholder('petTab', this.el.querySelector('.gnomName').innerHTML, this.options.petPageUrl);
		}

		//Handle popup after page has been loaded completely
		setTimeout(this.onPopupTimer.bind(this), 0);
	}

	onPopupTimer() {
		if (this.options.hatching != undefined) {
			if (this.options.hatching != "None")
				this.el.closest('.tabbedApplication').querySelector('.imageBox .hatch').style.display = 'block';
			else
				this.el.closest('.tabbedApplication').querySelector('.imageBox .hatch').style.display = 'none';
		}

		if (this.options.hatchPopupUrl != undefined) {
			if (!this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.isPopupVisible())
				this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.showPopup(this.options.hatchPopupUrl);
		}

		if (this.options.petNamePopup != undefined) {
			if (!this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.isPopupVisible())
				this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.showPopup(this.options.petNamePopup);
		}

		if (this.options.timer != undefined) {
			var actionTimer = this.el.closest('.tabbedApplication').querySelector('.actionTimer');

			if (actionTimer != undefined) {
				actionTimer.attachedObj.setTime(this.options.timer);
			}
		}
	}

	onTimer() {
		axios(this.options.url, {
			method: 'get'
		}).then((response) => {
			this.onBoxLoaded(response);
		});
	}

	onBoxLoaded(req) {
		try {
			var json = req.data;
		} catch (e) {
			return;
		}

		if (json.success) {
			replaceElement(this.el, json.box);
		}
	}
}
